import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Meta, Title } from '@angular/platform-browser';
import { Globals } from './globals';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    constructor(
        public translate: TranslateService,
        public title: Title,
        public meta: Meta,
        public globals: Globals
    ) {
        translate.setDefaultLang('vi');
        translate.use('vi');
        this.title.setTitle(this.globals.title.name);
        this.meta.addTag({ name: 'description', content: this.globals.title.description });
        this.meta.addTag({ name: 'keywords', content: this.globals.title.keywords });
        let shortcut = document.querySelector("[type='image/x-icon']");
        if(shortcut){
            shortcut.setAttribute('href',this.globals.title.shortcut);
        }
    }
}



// WEBPACK FOOTER //
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/app/app.component.ts